export const COOKIE_NAME_EMAIL_MARKETING_COUNTDOWN =
  'hideEmailMarketingCountdown';

export const EMAIL_MARKETING_TRIAL_DATE_EXPIRED = 'Expired';
